import { useState } from 'react'
import { Collapse, IconButton, Paper, Stack, Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

type CollapsableProps = {
  title: string
  children: React.ReactNode
}

const Collapsable = ({ title, children }: CollapsableProps) => {
  const [expanded, setExpanded] = useState(false)

  return (
    <Paper
      elevation={1}
      sx={{
        p: 2,
        borderRadius: '4px',
        bgcolor: 'grey.50',
      }}
    >
      <Stack>
        <Stack direction="row" spacing={2}>
          <IconButton
            size="small"
            onClick={() => setExpanded(!expanded)}
            aria-expanded={expanded}
            aria-label="toggle page expansion"
            sx={{
              transform: expanded ? 'rotate(0deg)' : 'rotate(-90deg)',
              transition: 'transform 200ms',
            }}
          >
            <ExpandMoreIcon />
          </IconButton>
          <Typography variant="h6">{title}</Typography>
        </Stack>
        <Collapse in={expanded}>{children}</Collapse>
      </Stack>
    </Paper>
  )
}

export default Collapsable
